import React, { FC } from 'react';
import { FlexFormGroup } from './Atoms';

type OptionalFormGroupProps = {
  enabled: boolean;
};

export const OptionalFormGroup: FC<OptionalFormGroupProps> = ({ enabled, children }) =>
  enabled ? <FlexFormGroup>{children}</FlexFormGroup> : <>{children}</>;
